module.exports = __webpack_public_path__ + "static/media/_cyprus.d2e18ce7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_cyprus.svg
// module id = 2314
// module chunks = 7